module.exports = __webpack_public_path__ + "media/images/lr-hd-e6876ac4.svg";